module.exports = __webpack_public_path__ + "img/16.aca7131c.png";